if (process.env.NODE_ENV !== 'production') {
  module.exports = require('./DevTools.dev');
} else {
  module.exports = require('./DevTools.prd');
}



// WEBPACK FOOTER //
// ./src/store/DevTools/index.js